import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { BlockCard } from "@whoosh/design-system/src/apps/PatronApp/components/BlockCard/BlockCard";

import { BlockSlot_block$key } from "./__generated__/BlockSlot_block.graphql";

export const BlockSlot = ({ blockRef }: { blockRef: BlockSlot_block$key }) => {
  const block = useFragment(BlockSlotBlockFragmentString, blockRef);

  return (
    <BlockCard
      title={t`Blocked`}
      text={block.blockSeries.name}
      durationMins={block.durationMins ?? 0}
      colorVariant={block.blockSeries.color}
    />
  );
};

export const BlockSlotBlockFragmentString = graphql`
  fragment BlockSlot_block on TimeSlotBlock {
    id
    startAt
    durationMins
    blockSeries {
      name
      color
    }
  }
`;
